import { UserGroups } from "src/app/core/models/users";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";
import {
  BehaviorSubject,
  Observable,
  catchError,
  finalize,
  map,
  tap,
} from "rxjs";
import { AddUserDTO, Users } from "../models/users";
import { EnvironmentService } from "./environment.service";
import { User } from "@auth0/auth0-angular";

@Injectable({
  providedIn: "root",
})
export class UserService {
  public activeUserName = signal<string | null>(null);
  private UserName = new BehaviorSubject<string>("");
  public userName = this.UserName.asObservable(); // used for loading user details in User Entity

  sendUserName(name: string) {
    if (this.UserName.value == name) return;
    this.UserName.next(name);
  }

  get getUserName() {
    return this.UserName.value;
  }

  private ToReload = new BehaviorSubject<boolean>(false);
  public toReload = this.ToReload.asObservable();

  reloadUserListOnAction(value: boolean) {
    this.ToReload.next(value);
  }

  private UserDetails = new BehaviorSubject<Users>(null);
  public userDetails = this.UserDetails.asObservable();

  updateUserDetails(userData: Users) {
    this.UserDetails.next(userData);
  }

  getUpdatedUserDetails() {
    return this.UserDetails.value;
  }

  constructor(private http: HttpClient, private env: EnvironmentService) {}

  getAddUserToIdentityServerFlag() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/GetAddUserToIdentityServerFlag";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getAllUsers() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/Users";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getAllUserNames(groupName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/UserNames";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("groupName", groupName);
    return this.http.get(baseUrl, { headers: headers });
  }

  getUserNameList() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/GetUserNamesList";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getAllDeploymentUsers(depName: string, getAllDepUser?: boolean) {
    let baseUrl;
    baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/Users/Name=" +
      depName;
    if (getAllDepUser != null && getAllDepUser == false) {
      baseUrl =
        this.env.envVariables.httpProtocol +
        this.env.envVariables.webHost +
        "UserInfoes/Users";
    }
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getUserValidity() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncConfiguration/SyncHPC/GetValidityDays";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getUserDetails(userId: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/GetUser/Id=" +
      userId;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getUserJobDirectoryPath(userId, depName) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/GetUserJobPath/Id=" +
      userId +
      "/Deployment=" +
      depName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }
  deleteUser(user: Users) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/deleteuser";
    let body = JSON.stringify(user);
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.put(baseUrl, body, { headers: headers });
  }

  addUser(user: Users) {
    try {
      let baseUrl =
        this.env.envVariables.httpProtocol +
        this.env.envVariables.webHost +
        "UserInfoes/adduser";
      let headers = new HttpHeaders();
      const userInfo = JSON.stringify(user);
      headers = headers
        .set("Content-Type", "application/json; charset=utf-8")
        .set("Cache-Control", "no-cache");
      return this.http.post<any>(baseUrl, userInfo, { headers: headers });
    } catch (Error) {}
  }

  addBulkUser(user: Array<AddUserDTO>) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/importUsers";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post<any>(baseUrl, user, { headers: headers });
  }

  editUser(user, updatedUserName: string) {
    try {
      let baseUrl =
        this.env.envVariables.httpProtocol +
        this.env.envVariables.webHost +
        "UserInfoes/updateinfo";
      let headers = new HttpHeaders();
      const userInfo = JSON.stringify(user);
      headers = headers
        .set("Content-Type", "application/json; charset=utf-8")
        .set("Cache-Control", "no-cache")
        .set("UpdatedUserName", updatedUserName);
      const upload$ = this.http.put<any>(baseUrl, userInfo, {
        headers: headers,
      });
      return upload$;
    } catch (Error) {}
  }

  // access control

  attachDeployment(attachDepObj) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/attachUser";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    return this.http.put(baseUrl, attachDepObj, { headers: headers });
  }

  changeUserPassword(username, password) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/changeUserPassword";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    return this.http.put(baseUrl, { username, password }, { headers: headers });
  }

  resetUserPassword(userId, adminId) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/" +
      userId +
      "/resetUserPassword";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("AdminId", adminId);

    return this.http.put(baseUrl, { headers: headers });
  }

  updateUserRole(updateUserObj) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/updateuserrole";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    return this.http.put(baseUrl, updateUserObj, { headers: headers });
  }

  detachDeployment(detachObj) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/detachuser";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    return this.http.put(baseUrl, detachObj, { headers: headers });
  }

  getUserProfileInfoes(username: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/UserProfile=" +
      username;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    return this.http.get(baseUrl, { headers: headers });
  }

  getUserRole(userProfileId: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/LoggedInUsersRole/UserProfile=" +
      userProfileId;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  updateJobSubmitUser(updateUserObj) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/updateuserid";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    return this.http.put(baseUrl, updateUserObj, { headers: headers });
  }

  getNodeGroup(userName: string, depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/UserName=" +
      userName +
      "/ProfileId=" +
      depName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getAllUserByUserRole(userRole: number) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/Users/UserRole=" +
      userRole;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getUsersByUserRoleAndDeployment(depName: string, userRole: number) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/Users/Name=" +
      depName +
      "/UserRole=" +
      userRole;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getAllocatedCoresData() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/Users/AllocatedCores";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getDeploymentForLoggedInUser() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/LoggedInUserDeployment";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  // User Group Api's

  getAllUserGroups() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/GetUserGroups";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getUserSpecificGroups(userName:string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `UserInfoes/GetUserSpecificGroups/${userName}`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  addUserGroup(group: UserGroups) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/AddUserGroup";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post(baseUrl, group, { headers: headers });
  }

  editUserGroup(oldGroupName: string, updatedGroup: UserGroups) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/UpdateUserGroup/groupName=" +
      oldGroupName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.put(baseUrl, updatedGroup, { headers: headers });
  }

  deleteUserGroup(groupName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/DeleteUserGroup/groupName=" +
      groupName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.delete(baseUrl, { headers: headers });
  }

  updateUsersInGroup(groupName: string, policyJson: any) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/UpdateUserInGroup/groupName=" +
      groupName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.put(baseUrl, policyJson, { headers: headers });
  }

  uploadStartUpFile(groupName: string, file: File) {
    const formData = new FormData();
    formData.append("File", file);
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `UserInfoes/${groupName}/AddStartupFile`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Cache-Control", "no-cache")
      .set("Access-Control-Allow-Origin", "*")
      .set(
        "Access-Control-Allow-Headers",
        "Origin, X-Requested-With, Content-Type, Accept"
      );

    const upload$ = this.http.post<any>(baseUrl, formData, {
      headers: headers,
      reportProgress: true,
      observe: "events",
    });

    return upload$;
  }

  removeStartUpFile(groupName: string, fileName) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `UserInfoes/${groupName}/RemoveStartupFile`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Cache-Control", "no-cache")
      .set("Access-Control-Allow-Origin", "*")
      .set(
        "Access-Control-Allow-Headers",
        "Origin, X-Requested-With, Content-Type, Accept"
      )
      .set("filename", fileName);

    return this.http.delete<any>(baseUrl, { headers: headers });
  }

  getJobPriority(userName: string, depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/UserName=" +
      userName +
      "/ProfileId=" +
      depName +
      "/JobPriority";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getAllocatedCoreQuota(userName: string, depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/UserName=" +
      userName +
      "/ProfileId=" +
      depName +
      "/AllocatedCoreQuota";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  updateUserColumnSetting(
    userName: string,
    columnSetting: string,
    tableName: string
  ) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `UserInfoes/UserName/${userName}/TableName/${tableName}/UpdateUserColumnSetting`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("ColumnSetting", `${columnSetting}`);
    return this.http.put(baseUrl, null, { headers: headers });
  }

  getColumnSetting(userName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `UserInfoes/UserName/${userName}/GetColumnSetting`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getUserMappingForUser(userName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `UserInfoes/UserName/${userName}/GetUserMapping`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getUserNamesForDeployment(depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/Deployment/" +
      depName +
      "/UserNames";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getUserGroupNamesForDeployment(depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/Deployment/" +
      depName +
      "/UserGroupsNames";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  addUserRdpTemplate(userName, rdpFile: File, fileType: string) {
    try {
      const formData = new FormData();
      formData.append("File", rdpFile);

      let baseUrl =
        this.env.envVariables.httpProtocol +
        this.env.envVariables.webHost +
        "UserInfoes/User/" +
        userName +
        "/UploadRdpFile";
      let headers = new HttpHeaders();
      headers = headers
        .set("Cache-Control", "no-cache")
        .set("Access-Control-Allow-Origin", "*")
        .set(
          "Access-Control-Allow-Headers",
          "Origin, X-Requested-With, Content-Type, Accept"
        )
        .set("FileType", fileType);

      const upload$ = this.http
        .post<any>(baseUrl, formData, {
          headers: headers,
          reportProgress: true,
          observe: "events",
        })
        .pipe(finalize(() => {}));

      return upload$;
    } catch (Error) {}
  }

  getAllDeploymentUserForJobFilter(depName: string, getAllDepUser?: boolean) {
    let baseUrl;
    if (getAllDepUser == null) {
      getAllDepUser = false;
    }

    baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/Deployment/" +
      depName +
      "/AllUsers/" +
      getAllDepUser;

    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("checkUserDepAccess", depName);
    return this.http.get(baseUrl, { headers: headers });
  }

  deleteMultipleUser(user: Users[]) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/deleteMultipleUser";
    let body = JSON.stringify(user);
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.put(baseUrl, body, { headers: headers });
  }

  getNotificationConfigForUser(userName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `UserInfoes/UserName/${userName}/GetNotificationConfiguration`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  updateNotificationConfiguration(newData, userName: string = null) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `UserInfoes/UpdateNotificationConfig/${userName}`;
    let headers = new HttpHeaders();
    const logInUiConfigs = JSON.stringify(newData);

    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    return this.http.post(baseUrl, logInUiConfigs, { headers: headers });
  }

  checkUserSettingsInGroup(groupName: string, usersNameList: string[]) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `UserInfoes/CheckUserSettingUpdated/${groupName}`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post(baseUrl, usersNameList, { headers: headers });
  }


  updateUserMapping(groupName: string, policyJson: any) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/UpdateUserMapping/nodeName=" +
      groupName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.put(baseUrl, policyJson, { headers: headers });
  }

  checkForAutoscale(user: string, depName: any) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/CheckForAutoscale";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("User", user)
      .set("Deployment", depName);
    return this.http.get(baseUrl, { headers: headers });
  }

  getUserTags() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/GetUserTag";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers }).pipe(
      map((data: any) => {
        if (data) return data?.userTag;
        else return null;
      }),
      catchError((err) => {
        return null;
      })
    );
  }
}
